<script setup lang="ts">
import type { ProductUpdate } from '../../models/whatsNew.types'

import { useFormat } from '@/shared/lib/format'
import { RichTextViewer } from '@/shared/ui/editor'

defineProps<{ item: ProductUpdate }>()

const format = useFormat()
</script>

<template>
  <article class="whats-new-item relative grid gap-sm pt-0 pr-md pb-xl pl-10">
    <span
      class="whats-new-item__rail absolute top-4 bottom-0 left-[0.45rem] w-[2px] bg-primary"
      aria-hidden="true"
    />
    <span
      class="whats-new-item__dot absolute top-[0.15rem] left-0 w-[0.9rem] h-[0.9rem] border-3 border-surface rounded-full bg-primary shadow-[0_0_0_2px_var(--ui-color-primary)]"
      aria-hidden="true"
    />
    <h3>{{ item.title }}</h3>
    <RichTextViewer :content="item.description" />
    <time :datetime="item.published_at ?? item.created_at">
      {{ format.formatDate(item.published_at ?? item.created_at) }}
    </time>
    <img v-if="item.media_url" :src="item.media_url" alt="" />
  </article>
</template>

<style scoped>
.whats-new-itemh3 {
  margin: 0;
  color: var(--ui-color-fg);
  font-size: 1rem;
}
.whats-new-item h3 {
  margin: 0;
  color: var(--ui-color-fg);
  font-size: 1rem;
}
.whats-new-itemtime {
  color: var(--ui-color-muted);
  font-size: 0.8125rem;
}
.whats-new-item time {
  color: var(--ui-color-muted);
  font-size: 0.8125rem;
}
.whats-new-itemimg {
  width: 100%;
  border: 1px solid var(--ui-color-border);
  border-radius: var(--ui-radius-md);
}
.whats-new-item img {
  width: 100%;
  border: 1px solid var(--ui-color-border);
  border-radius: var(--ui-radius-md);
}
</style>
